class SizeGuide extends HTMLElement {
  constructor() {
    super();

    this.classes = {
      sizeGuide: '.js-size-guide-overlay',
      openBtn: '.js-size-guide-btn',
      closeBtn: '.js-size-guide-close',
      openClass: 'open'
    }
    this.setSizeGuideButtons();
  }

 /**
  * setSizeGuideButtons
  *
  * Method that sets all size guide modal button events
  */
  setSizeGuideButtons() {
    const sizeGuide = document.querySelector(this.classes.sizeGuide);
    const openBtn = document.querySelector(this.classes.openBtn);
    const closeBtn = document.querySelector(this.classes.closeBtn);

    if (!(sizeGuide && openBtn && closeBtn)) {
      return;
    }

    openBtn.addEventListener('click', (e) => {
      e.preventDefault();
      this.sizeGuideOpen(sizeGuide, closeBtn);
    });

    closeBtn.addEventListener('click', (e) => {
      e.preventDefault();
      this.sizeGuideClose(sizeGuide);
    });
  }

 /**
  * sizeGuideOpen
  *
  * Method that opens the size guide modal and traps focus on the close button
  */
  sizeGuideOpen(sizeGuide, closeBtn) {
    if (!sizeGuide.classList.contains(this.classes.openClass)) {
      sizeGuide.classList.add(this.classes.openClass);
      this.setTrapFocus(sizeGuide, closeBtn);
    }
  }

 /**
  * sizeGuideClose
  *
  * Method that closes the size guide modal
  */
  sizeGuideClose(sizeGuide) {
    if (sizeGuide.classList.contains(this.classes.openClass)) {
      sizeGuide.classList.remove(this.classes.openClass);
    }
  }
  
 /**
  * setTrapFocus
  *
  * Method that uses the theme's global trapFocus function to enable tabbing on size guide modal.
  *
  * @returns {null}
  */
  setTrapFocus(container, elementToFocus) {
    if ( typeof trapFocus != 'function') {
      return null;
    }
    trapFocus(container, elementToFocus);
  }
}

customElements.define('size-guide', SizeGuide);